import { EnumHelperBase, type EnumDataObject } from './enum.helpers';

export enum PAYMENT_METHOD {
	CREDIT_CARD = 1,
	BANK_TRANSFER = 2,
	GOOGLE_PAY = 3,
	APPLE_PAY = 4,
	CARD_TERMINAL = 5,
	CASH = 6,
	CHIP = 7,
	VIP = 8,
	PASS_VOUCHER = 9,
	ORGANIZER = 10,
	CLICK_TO_PAY = 11,
}

export interface PaymentMethodEnumBaseData extends EnumDataObject<PaymentMethodEnumBaseExtraData, PAYMENT_METHOD, 'paymentMethodId'> {}

export interface PaymentMethodEnumBaseExtraData {
	/** Indicates whether Ticketing supports this payment method */
	isPassSupported: boolean;
	/** Indicates whether POS supports this payment method */
	isPosSupported: boolean;
}

/**
 * Base PaymentMethod enumeration class
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/global.png
 */
class PaymentMethodEnumBase extends EnumHelperBase<PaymentMethodEnumBaseExtraData, PAYMENT_METHOD, 'paymentMethod', 'paymentMethodId'> {
	constructor() {
		super(
			'paymentMethod',
			{
				[PAYMENT_METHOD.CREDIT_CARD]: { isPassSupported: true, isPosSupported: false },
				[PAYMENT_METHOD.BANK_TRANSFER]: { isPassSupported: true, isPosSupported: false },
				[PAYMENT_METHOD.GOOGLE_PAY]: { isPassSupported: true, isPosSupported: false },
				[PAYMENT_METHOD.APPLE_PAY]: { isPassSupported: true, isPosSupported: false },
				[PAYMENT_METHOD.CARD_TERMINAL]: { isPassSupported: false, isPosSupported: true },
				[PAYMENT_METHOD.CASH]: { isPassSupported: false, isPosSupported: true },
				[PAYMENT_METHOD.CHIP]: { isPassSupported: false, isPosSupported: true },
				[PAYMENT_METHOD.VIP]: { isPassSupported: false, isPosSupported: true },
				[PAYMENT_METHOD.PASS_VOUCHER]: { isPassSupported: false, isPosSupported: true },
				[PAYMENT_METHOD.ORGANIZER]: { isPassSupported: true, isPosSupported: false },
				[PAYMENT_METHOD.CLICK_TO_PAY]: { isPassSupported: true, isPosSupported: false },
			},
			'paymentMethodId',
			null,
		);
	}
}

export const paymentMethodEnumBase = new PaymentMethodEnumBase();
